<script>
  import JumpTem from './JumpTem.vue'
  import imageUpload from '@/components/ImageUpload/index.vue'
  import { getBannerPosition } from '../../config/format'

  export default {
    name: 'banner3',
    components: { JumpTem, imageUpload },
    props: {
      value: {
        type: Object,
        default: () => {}
      },
      slotKeys: {
        type: Array,
        default: () => ['banner1', 'banner2', 'banner3', 'banner4']
      },
      // 新增：是否使用tab风格
      useTabStyle: {
        type: Boolean,
        default: false
      },
      // 是否编辑
      isEdit: {
        type: Boolean,
        default: false
      },
      isDefaultBanner: {
        type: Boolean,
        default: false
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data() {
      return {
        rules: {
          slotKey: [{ required: true, message: '请选择banner位置', trigger: 'change' }],
          imgUrl: [{ required: true, message: '请上传banner图', trigger: 'change' }],
          name: [
            { required: true, message: '请输入广告名称', trigger: 'blur' },
            { max: 30, message: '不超过30个字', trigger: 'blur' }
          ]
        },
        dataMap: {}, // 存储各个位置的数据
        validationErrors: {}, // 存储校验错误信息
        activeTab: '', // 当前激活的tab
        currentSlotKey: '' // 当前选中的位置
      }
    },
    created() {
      // 初始化组件状态
      this.initializeComponent()
    },
    computed: {
      // 获取当前激活的表单引用
      activeFormRef() {
        return this.$refs[`${this.currentSlotKey}_bannerForm`]
      },
      // 获取当前激活的JumpTem引用
      activeJumpTemRef() {
        return this.$refs[`${this.currentSlotKey}_JumpTem`]
      },
      // 当前位置的数据，用于双向绑定
      currentData() {
        return this.dataMap[this.currentSlotKey] || {}
      },
      positionTitle() {
        return (val) => {
          return getBannerPosition({ slotKey: val })
        }
      },
      width() {
        const map = new Map([
          ['left_top', 320],
          ['left_bottom', 320],
          ['right', 326]
        ])
        return map.get(this.activeTab || this.currentSlotKey)
      },
      height() {
        const map = new Map([
          ['left_top', 200],
          ['left_bottom', 200],
          ['right', 412]
        ])
        return map.get(this.activeTab || this.currentSlotKey)
      }
    },
    watch: {
      value: {
        handler(val) {
          if (val && val.slotKey && val.slotKey !== this.currentSlotKey) {
            // 当value中的slotKey变化时，更新当前位置和相关状态
            this.updateCurrentPosition(val.slotKey)
          }
        },
        deep: true
      },
      slotKeys: {
        handler() {
          // 当可用位置列表变化时，重新初始化数据
          this.initializeDataMap()
        }
      },
      // 监听currentSlotKey变化
      currentSlotKey(newKey, oldKey) {
        if (newKey !== oldKey) {
          // 更新内部状态
          this.activeTab = newKey

          // 仅同步slotKey变化，这是父组件可能需要的信息
          this.$emit('change', {
            ...this.value,
            slotKey: newKey
          })
        }
      }
    },
    methods: {
      // 初始化组件
      initializeComponent() {
        // 初始化当前位置
        this.currentSlotKey = this.value.slotKey || this.slotKeys[0]

        // 初始化每个位置的数据
        this.initializeDataMap()

        // 初始化激活的tab
        this.activeTab = this.currentSlotKey
      },

      // 更新当前位置和相关状态
      updateCurrentPosition(slotKey) {
        this.currentSlotKey = slotKey
        this.updateSlotKeyInDataMap(slotKey)
        this.activeTab = slotKey
      },

      // 初始化数据映射
      initializeDataMap() {
        if (this.isEdit) {
          // 编辑模式下，只初始化当前slotKey的数据
          const slotKey = this.value.slotKey
          if (slotKey) {
            // 确保displayChannelList正确初始化
            this.$set(this.dataMap, slotKey, {
              displayChannelList: this.value.displayChannel
                ? this.value.displayChannel.split(',')
                : [],
              // 只复制banner相关的特定字段，避免覆盖核心字段
              imgUrl: this.value.imgUrl || '',
              // JumpTem组件需要的字段
              jumpType: this.value.jumpType,
              jumpUrl: this.value.jumpUrl,
              pageUrl: this.value.pageUrl || '',
              pageUrlType: this.value.pageUrlType || '', // 默认为空
              appId: this.value.appId || '',
              appletOriginalId: this.value.appletOriginalId || '',
              name: this.value.name,
              slotKey
            })
          }
        } else {
          // 新增模式，初始化所有位置的数据
          for (let i = 0; i < this.slotKeys.length; i++) {
            const key = this.slotKeys[i]
            if (!this.dataMap[key]) {
              this.$set(this.dataMap, key, {
                slotKey: key,
                displayChannelList: [],
                marketImgUrl: '',
                imgUrl: '',
                marketText: '',
                // JumpTem组件需要的字段
                pageUrl: '',
                pageUrlType: '', // 默认为空
                appId: '',
                appletOriginalId: '',
                name: ''
              })
            }
          }
        }

        // 确保有slotKey
        this.updateSlotKeyInDataMap(this.currentSlotKey)
      },

      // 更新所有位置的数据中的slotKey
      updateSlotKeyInDataMap(slotKey) {
        // 更新当前位置的数据
        if (this.dataMap[slotKey]) {
          this.$set(this.dataMap[slotKey], 'slotKey', slotKey)
        }
      },

      // 校验单个表单
      validateBannerForm() {
        return new Promise((resolve, reject) => {
          try {
            const slotKey = this.currentSlotKey

            // 获取当前激活的JumpTem组件
            const jumpTemRef = this.activeJumpTemRef

            // 如果找不到JumpTem组件，直接拒绝
            if (!jumpTemRef) {
              reject(new Error(`找不到位置 ${slotKey} 的跳转表单`))
              return
            }

            // 校验JumpTem组件
            jumpTemRef[0]
              .validateForm()
              .then((jumpTemData) => {
                // 获取当前激活的表单
                const formRef = this.activeFormRef

                // 如果找不到表单，直接拒绝
                if (!formRef) {
                  reject(new Error(`找不到位置 ${slotKey} 的Banner表单`))
                  return
                }

                // 校验Banner表单
                formRef[0].validate((valid) => {
                  if (valid) {
                    // 确保将jumpTemData中的所有字段保存到dataMap中
                    // 特别是处理displayChannel字段
                    Object.keys(jumpTemData).forEach((key) => {
                      this.$set(this.dataMap[slotKey], key, jumpTemData[key])
                    })

                    // 合并JumpTem数据和当前表单数据
                    const validData = {
                      ...this.dataMap[slotKey]
                    }
                    resolve(validData)
                  } else {
                    reject(new Error(`位置 ${slotKey} 的Banner表单校验失败`))
                  }
                })
              })
              .catch((error) => {
                reject(error)
              })
          } catch (error) {
            reject(error)
          }
        })
      },

      // 校验所有表单
      validateAllForms(slotKeys) {
        return new Promise((resolve, reject) => {
          try {
            // 清空校验错误记录
            this.validationErrors = {}

            // 如果不使用Tab风格且不允许多选，则只校验当前选中的位置
            if (!this.useTabStyle) {
              // 只校验当前选中的位置
              this.validateBannerForm()
                .then((validData) => {
                  // 只返回当前位置的数据和slotKey，不合并父组件的value
                  resolve({
                    ...validData,
                    slotKey: this.currentSlotKey
                  })
                })
                .catch((error) => {
                  reject(error)
                })
              return
            }

            // 获取要校验的位置列表
            const keysToValidate = slotKeys || this.slotKeys

            // 记住当前位置
            const originalSlotKey = this.currentSlotKey

            // 使用顺序校验而不是并行校验，以确保位置切换的准确性
            const validateSequentially = async () => {
              // 依次校验每个位置
              for (let i = 0; i < keysToValidate.length; i++) {
                const slotKey = keysToValidate[i]

                // 设置当前位置
                this.currentSlotKey = slotKey
                this.activeTab = slotKey

                try {
                  // 等待校验完成
                  await this.validateBannerForm()
                } catch (error) {
                  // 记录校验失败的位置和错误信息
                  this.validationErrors[slotKey] = error.message || '校验失败'

                  // 已经在失败的位置，直接抛出错误
                  throw new Error(
                    `位置 ${this.positionTitle(slotKey)} 校验失败: ${error.message || '校验失败'}`
                  )
                }
              }

              // 全部校验通过，恢复原来的位置
              this.currentSlotKey = originalSlotKey
              this.activeTab = originalSlotKey

              // 只返回必要的数据：当前slotKey和所有位置的数据
              return {
                slotKey: this.currentSlotKey,
                allPositionsData: { ...this.dataMap }
              }
            }

            // 执行顺序校验
            validateSequentially()
              .then((result) => resolve(result))
              .catch((error) => reject(error))
          } catch (error) {
            reject(error)
          }
        })
      },

      // 处理上一步 - 简化，直接在组件内处理
      handlePrev() {
        const currentIndex = this.slotKeys.findIndex((key) => key === this.currentSlotKey)
        const prevIndex = Math.max(0, currentIndex - 1)
        const prevSlotKey = this.slotKeys[prevIndex]

        // 设置当前位置
        this.currentSlotKey = prevSlotKey
        this.activeTab = prevSlotKey

        return prevIndex // 返回新索引，供父组件参考
      },

      // 处理下一步 - 简化，直接在组件内处理
      handleNext() {
        const currentIndex = this.slotKeys.findIndex((key) => key === this.currentSlotKey)
        const nextIndex = Math.min(this.slotKeys.length - 1, currentIndex + 1)
        const nextSlotKey = this.slotKeys[nextIndex]

        // 设置当前位置
        this.currentSlotKey = nextSlotKey
        this.activeTab = nextSlotKey

        return nextIndex // 返回新索引，供父组件参考
      },

      // 获取当前位置索引
      getCurrentIndex() {
        return this.slotKeys.findIndex((key) => key === this.currentSlotKey)
      },

      // 获取所有数据
      getAllData() {
        return {
          currentSlotKey: this.currentSlotKey,
          allPositionsData: this.dataMap
        }
      },

      // 保存当前位置的数据
      saveCurrentSlotData() {
        // 当前数据已经实时绑定到dataMap中，不需要额外保存
        return this.dataMap
      },

      // 更新dataMap中指定位置和属性的值
      updateDataMap(slotKey, prop, value) {
        if (this.dataMap[slotKey]) {
          this.$set(this.dataMap[slotKey], prop, value)
        }
      },

      getImg(url, prop, slotKey) {
        this.updateDataMap(slotKey, prop, url)
      },

      // 处理位置切换事件
      slotKeyChange(val) {
        // 处理从el-tabs传来的事件对象
        let newSlotKey = val

        // 如果是tab-click事件，从事件对象中提取选项卡名称
        if (val && val.name) {
          newSlotKey = val.name
        }

        // 更新当前位置
        this.currentSlotKey = newSlotKey
      }
    }
  }
</script>

<template>
  <div>
    <JumpTem
      v-for="key in slotKeys"
      :key="key"
      :value="dataMap[key]"
      @change="(newVal) => $set(dataMap, key, newVal)"
      :ref="`${key}_JumpTem`"
      v-show="currentSlotKey === key"
      :mark="key"
      :isDefaultBanner="isDefaultBanner"
    >
      <template v-slot:banner>
        <el-form
          :ref="`${key}_bannerForm`"
          :model="dataMap[key]"
          :rules="rules"
          label-width="120px"
          size="small"
        >
          <!-- banner位置选择 -->
          <el-form-item label="banner 位置" prop="slotKey">
            <div v-if="!isEdit">
              <!-- Tab样式 -->
              <div v-if="useTabStyle" class="banner-tabs">
                <el-tabs v-model="activeTab" @tab-click="slotKeyChange">
                  <el-tab-pane
                    v-for="item in slotKeys"
                    :key="item"
                    :label="positionTitle(item)"
                    :name="item"
                  />
                </el-tabs>
              </div>

              <!-- 单选按钮组样式 -->
              <el-radio-group v-else v-model="currentSlotKey" @change="slotKeyChange">
                <el-radio v-for="item in slotKeys" :key="item" :label="item">{{
                  positionTitle(item)
                }}</el-radio>
              </el-radio-group>
            </div>
            <div v-else>{{ positionTitle(dataMap[key].slotKey) }}</div>
          </el-form-item>

          <el-form-item label="名称" prop="name" v-if="isDefaultBanner">
            <el-input
              v-model="dataMap[key].name"
              placeholder="请输入广告名称"
              maxlength="30"
              show-word-limit
              style="width: 400px"
            />
          </el-form-item>

          <!-- banner图 -->
          <el-form-item label="banner图" prop="imgUrl">
            <imageUpload
              :imageList="dataMap[key].imgUrl ? [{ url: dataMap[key].imgUrl }] : []"
              :limit="1"
              :fileSize="1"
              :isShowTip="true"
              :WHtip="true"
              :width="width"
              :height="height"
              :fileType="['png', 'jpg']"
              accept=".jpg,.png"
              :multiple="false"
              @input="(val) => getImg(val, 'imgUrl', key)"
              code="banner"
            />
          </el-form-item>
        </el-form>
      </template>
    </JumpTem>
  </div>
</template>

<style scoped lang="scss">
  .upload-tip {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 5px;
  }

  .banner-tabs {
    width: 100%;

    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__content {
      display: none; /* 隐藏内容区域，因为我们只需要tab标签 */
    }
  }
</style>
